/**
 * @generated SignedSource<<186910a2b5ba4637df7b5b4d9c26f433>>
 * @relayHash 1e5caf2ff3ce1aa7b376b1383684f83c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 075afa9ccfaf7aeb4580225ceccd8e352b90b92811039ac55eac933591820624

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_onboardingListQuery$variables = {
  cloudId: string;
};
export type ui_onboardingListQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"table_onboardingHub_OnboardingListTable">;
};
export type ui_onboardingListQuery = {
  response: ui_onboardingListQuery$data;
  variables: ui_onboardingListQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ui_onboardingListQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "table_onboardingHub_OnboardingListTable"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ui_onboardingListQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          }
        ],
        "concreteType": "JiraOnboardingConfigConnection",
        "kind": "LinkedField",
        "name": "jira_onboardingConfigs",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraOnboardingConfigEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "JiraOnboardingConfig",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "onboardingConfigAri"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "targetValues"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "updatedAt"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "075afa9ccfaf7aeb4580225ceccd8e352b90b92811039ac55eac933591820624",
    "metadata": {},
    "name": "ui_onboardingListQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "81ea608ed44dbb4a866a00dc9312fcea";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
